<template>
  <div class="lesson-ended-card">
    <div class="lesson-ended-card__panel">
      <div class="lesson-ended-card__title">本节已播完</div>
      <template v-if="nextLesson">
        <div class="lesson-ended-card__next-label">下一节</div>
        <div class="lesson-ended-card__next-name" :title="nextLessonName">
          {{ nextLessonName }}
        </div>
      </template>
      <div v-else class="lesson-ended-card__tip">{{ lastTip }}</div>
      <div class="lesson-ended-card__actions">
        <button class="lesson-ended-card__btn" @click="$emit('replay')">
          重播
        </button>
        <button
          v-if="nextLesson"
          class="lesson-ended-card__btn lesson-ended-card__btn--primary"
          @click="$emit('next')"
        >
          播放下一节
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LessonEndedCard",
  props: {
    nextLesson: {
      type: Object,
      default: null,
    },
    // 没有可播的下一节时的提示；宿主可按原因定制（如后面只剩图文课）
    lastTip: {
      type: String,
      default: "已是最后一节",
    },
  },
  computed: {
    nextLessonName() {
      return this.nextLesson?.lesson_name || "下一节课时";
    },
  },
};
</script>

<style scoped lang="scss">
.lesson-ended-card {
  position: absolute;
  inset: 0;
  // 要盖住播放器中间那颗 .big-play-btn（z-index: 1000）和 .electron-play-header（1003），
  // 但仍低于控制条，播完后还能直接拖进度条
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(9, 15, 28, 0.82);
  backdrop-filter: blur(2px);
}

.lesson-ended-card__panel {
  width: 320px;
  max-width: 80%;
  padding: 24px;
  border-radius: 10px;
  background: rgba(23, 33, 51, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
  box-sizing: border-box;
}

.lesson-ended-card__title {
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #ffffff;
}

.lesson-ended-card__next-label {
  margin-top: 16px;
  font-size: 12px;
  line-height: 17px;
  color: rgba(255, 255, 255, 0.5);
}

.lesson-ended-card__next-name {
  margin-top: 4px;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.lesson-ended-card__tip {
  margin-top: 12px;
  font-size: 13px;
  line-height: 18px;
  color: rgba(255, 255, 255, 0.5);
}

.lesson-ended-card__actions {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.lesson-ended-card__btn {
  min-width: 88px;
  height: 34px;
  padding: 0 16px;
  border-radius: 17px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: transparent;
  font-size: 14px;
  line-height: 1;
  color: rgba(255, 255, 255, 0.85);
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.45);
    color: #ffffff;
  }

  &--primary {
    border-color: #00c89d;
    background: #00c89d;
    color: #ffffff;

    &:hover {
      border-color: #00b48d;
      background: #00b48d;
      color: #ffffff;
    }
  }
}
</style>
